// extracted by mini-css-extract-plugin
export default {"tabContainer":"styles_tabContainer__db2lR"};